<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    isExtended
    @submitFilters="getAllMasterGroupClassStudents"
  >
    <template #title>
      زبان آموز های کلاس گروهی {{ computedGroupClassTitle }} با استاد
      {{ computedGroupClassMasterName }}
    </template>
    <template #extend>
      <BRow class="w-100 pl-0 ml-0" v-if="groupClassDetails">
        <BCol cols="12" md="6" class="w-100">
          <MasterGroupClassDetailsCard
            :groupClassDetails="groupClassDetails"
          ></MasterGroupClassDetailsCard>
        </BCol>
        <BCol cols="12" md="6">
          <MasterGroupClassDetailsIncomeCard
            :groupClassDetails="groupClassDetails"
          >
          </MasterGroupClassDetailsIncomeCard>
        </BCol>
      </BRow>
    </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="groupClassStudentsSearchCommand"
        inputLabel="جستجو بر اساس نام زبان آموز"
        inputPlaceholder="علی..."
        v-model.trim="getAllGroupClassStudentFilters.searchCommand"
        @enter="getAllMasterGroupClassStudents"
      ></SearchInput>
    </template>
    <CustomTable
      v-if="groupClassStudentsList"
      :pageNumber="getAllGroupClassStudentFilters.pageNumber"
      :count="getAllGroupClassStudentFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="groupClassStudentsList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (getAllGroupClassStudentFilters.pageNumber - 1) *
                getAllGroupClassStudentFilters.count
          )
        }}
      </template>
      <template #studentUserFullName="data">
        <b-link
          :to="`/master/users/${data.item.studentUserId}`"
          class="text-info"
        >
          {{ data.item.studentUserFullName }}
        </b-link>
      </template>
      <template #cancel="data">
        <BBadge
          pill
          :variant="data.item.cancel ? 'danger' : 'success'"
          class="font-weight-normal"
        >
          {{ data.item.cancel ? "بله" : "خیر" }}
        </BBadge>
      </template>
      <template #isPayBack="data">
        <BBadge
          pill
          :variant="data.item.isPayBack ? 'danger' : 'success'"
          class="font-weight-normal"
        >
          {{ data.item.isPayBack ? "بله" : "خیر" }}
        </BBadge>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    selectedMasterGroupClassId: {
      type: [String, Number],
    },
  },
  mounted() {
    if (this.computedPageRouteQuery) {
      this.getAllGroupClassStudentFilters.pageNumber =
        this.computedPageRouteQuery;
    } else {
      this.getAllGroupClassStudentFilters.pageNumber = 1;
    }
    this.getAllMasterGroupClassStudents();
  },
  data() {
    return {
      isLoading: false,
      groupClassDetails: null,
      totalCount: null,
      getAllGroupClassStudentFilters: {
        pageNumber: 1,
        count: 10,
        groupClassMasterId: null,
        searchCommand: null,
      },
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "studentUserFullName",
          label: "نام کاربر",
        },
        {
          key: "create_At",
          label: "تاریخ رزرو",
          formatter: (value) => this.customFullDateTimeConvert(value),
        },
        {
          key: "masterIncome",
          label: "درآمد استاد",
          formatter: (value) =>
            `${Intl.NumberFormat("en-US").format(value)} تومان`,
        },
        {
          key: "cancel",
          label: "کنسل شده",
        },
        {
          key: "isPayBack",
          label: "وجه بازگشتی",
        },
      ],
    };
  },
  methods: {
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          groupClassStudentPageNumber: pageNumber,
        },
      });
    },
    changePage(pageNumber) {
      this.getAllGroupClassStudentFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getAllMasterGroupClassStudents();
    },
    async getAllMasterGroupClassStudents() {
      try {
        this.getAllGroupClassStudentFilters.groupClassMasterId =
          this.selectedMasterGroupClassId;
        this.isLoading = true;
        const _this = this;
        const getMasterGroupClassStudents = new GetMasterGroupClassStudents(
          _this
        );
        getMasterGroupClassStudents.setRequestParam(
          _this.getAllGroupClassStudentFilters
        );
        await getMasterGroupClassStudents.fetch((res) => {
          if (res.isSuccess) {
            _this.groupClassDetails = res.data;
            _this.totalCount = res.data.groupClassStudentsCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.groupClassStudentPageNumber) {
        return this.$route.query.groupClassStudentPageNumber;
      }
      return null;
    },
    groupClassStudentsList() {
      if (this.groupClassDetails && this.groupClassDetails.groupClassStudents) {
        return this.groupClassDetails.groupClassStudents;
      }
      return null;
    },
    computedGroupClassTitle() {
      if (this.groupClassDetails && this.groupClassDetails.groupClassName) {
        return this.groupClassDetails.groupClassName;
      }
    },
    computedGroupClassMasterName() {
      if (this.groupClassDetails && this.groupClassDetails.masterFullName) {
        return this.groupClassDetails.masterFullName;
      }
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    CustomTable,
    SearchInput,
    MasterGroupClassDetailsCard,
    MasterGroupClassDetailsIncomeCard,
    BLink,
    BBadge,
    BCard,
    BCardText,
    BRow,
    BCol,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import MasterGroupClassDetailsCard from "@/views/components/GroupClass/MasterGroupClass/MasterGroupClassDetailsCard.vue";
import MasterGroupClassDetailsIncomeCard from "@/views/components/GroupClass/MasterGroupClass/MasterGroupClassDetailsIncomeCard.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BLink, BBadge, BCard, BCardText, BRow, BCol } from "bootstrap-vue";
import { GetMasterGroupClassStudents } from "@/libs/Api/GroupClass";
</script>
